window.onWizzyScriptLoaded = function() {

  var WIZZY_CTA_ATTRIBUTES = {
    showNotifyMe: "product_show_notify_me_custom",
    notifyMeWaitlist: "product_notify_me_waitlist_custom",
    showPreorder: "product_show_preorder_custom",
    showComingSoon: "product_show_coming_soon_custom",
    tags: "product_tags"
  };

  function wizzyAttributeValue(attr) {
    return attr && attr.values && attr.values[0] && attr.values[0].value
      ? attr.values[0].value[0]
      : null;
  }

  function getMarketInventorySource() {
    const marketId = window.Shopify?.country === "IN" ? "50584944800" : "113107501216";
    return [
      {
        key: marketId,
        inStock: [true, false],
      },
    ];
  }

  function wizzyAttributeIsTrue(attr) {
    var value = wizzyAttributeValue(attr);
    if (typeof value === "boolean") return value;
    if (value == null) return false;
    return ["true", "yes", "1"].indexOf(String(value).trim().toLowerCase()) !== -1;
  }

  function wizzyHasTag(attr, tag) {
    var value = wizzyAttributeValue(attr);
    if (!value) return false;
    return String(value)
      .split(",")
      .map(function (entry) {
        return entry.trim().toLowerCase();
      })
      .indexOf(tag) !== -1;
  }

  function wizzyVariantInStock(entry) {
    if (!entry) return false;
    return entry.inStock === true || entry.inStock === "true" || entry.inStock === 1;
  }

  // product_variant_prices[].inStock is per-size; sold out only if every variant is OOS
  function areAllVariantPricesOutOfStock(attr) {
    if (!attr || !Array.isArray(attr.values) || attr.values.length === 0) return false;
    return attr.values.every(function (entry) {
      return !wizzyVariantInStock(entry);
    });
  }

  function setWizzyCta(product) {
    var settings = window.wizzyCtaSettings || {};

    product.ctaEarlyAccess = settings.enableEarlyAccess === true && product.isEarlyAccessProduct === true;
    product.ctaPreorder =
      product.ctaEarlyAccess === false && settings.enablePreorder === true && product.showPreorder === true;
    product.ctaNotify =
      product.ctaEarlyAccess === false &&
      product.ctaPreorder === false &&
      settings.enableNotifyMe === true &&
      product.showNotifyMe === true;
    product.ctaNotifyWaitlist = product.ctaNotify && product.notifyMeWaitlist === true;
    product.ctaSoldOut =
      product.isOutOfStock === true &&
      product.ctaEarlyAccess === false &&
      product.ctaPreorder === false &&
      product.ctaNotify === false;
    product.ctaAddToBag =
      product.isOutOfStock !== true &&
      product.ctaEarlyAccess === false &&
      product.ctaPreorder === false &&
      product.ctaNotify === false;
  }

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function(data) {
      if (data.api === 'search' && data.response?.payload) {
        var payload = data.response.payload;
        var isEmpty = payload.total === null || !payload.result || payload.result.length === 0;

        if (isEmpty) {
          data.response.payload.total = 0;
          data.response.payload.result = [];
          data.response.status = 0; 
        }
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function(products) {
      try {
        
        var urlByGroupId = {};
        products.forEach(function (product) {
          if (product.groupId != null && product.url) {
            urlByGroupId[String(product.groupId)] = product.url;
          }
        });
  
        products.forEach(function (product) {
          if (Array.isArray(product.images) && product.images.length) {
            product.images = product.images.filter(Boolean).slice(0, 3);
          }
          if (!Array.isArray(product.attributes)) {
            setWizzyCta(product);
            return;
          }
          product.attributes.forEach(function (attr) {
            if (attr.id === "product_pretitle_info") {
              product.preTitle = attr.values?.[0]?.value?.[0];
            }
            if (attr.id === "product_badges_info") {
              var badge = attr.values?.[0]?.value?.[0];
              if (badge === "Trending") {
                product.trendingBadge = badge;
              }
              if (badge === "New") {
                product.newBadge = badge;
              }
              if (badge === "Coming Soon") {
                product.comingSoon = badge;
              }
              if (badge === "Live Now") {
                product.liveNow = badge;
              }
              
            }
            if (attr.id === "combined_listing_children") {
              product.colourSwatches = buildSwatchesFromCombinedListing(
                attr,
                product,
                urlByGroupId
              );
              product.hasColourSwatches = product.colourSwatches.length > 0;
              // Mobile cards are ~half width — 5×2.4rem swatches push Add to Bag off-screen
              var maxSwatches = window.matchMedia('(max-width: 768px)').matches ? 3 : 5;
              if (product.colourSwatches.length > maxSwatches) {
                product.colourSwatchesMore = product.colourSwatches.length - maxSwatches;
                product.colourSwatches = product.colourSwatches.slice(0, maxSwatches);
              }
            }
            
            if (attr.id === "product_handle") {
                product.handle=attr.values[0].value[0];
            }

            if (attr.id === "product_variant_prices") {
              product.isOutOfStock = areAllVariantPricesOutOfStock(attr);
            }

            if (attr.id === WIZZY_CTA_ATTRIBUTES.showNotifyMe) {
              product.showNotifyMe = wizzyAttributeIsTrue(attr);
            }

            if (attr.id === WIZZY_CTA_ATTRIBUTES.notifyMeWaitlist) {
              product.notifyMeWaitlist = wizzyAttributeIsTrue(attr);
            }

            if (attr.id === WIZZY_CTA_ATTRIBUTES.showPreorder) {
              product.showPreorder = wizzyAttributeIsTrue(attr);
            }

            if (attr.id === WIZZY_CTA_ATTRIBUTES.showComingSoon) {
              product.showComingSoon = wizzyAttributeIsTrue(attr);
            }

            if (attr.id === WIZZY_CTA_ATTRIBUTES.tags) {
              product.isEarlyAccessProduct = wizzyHasTag(attr, "early-access");
            }

          });

          setWizzyCta(product);
        });
      } catch (error) {
        console.log("error",error);
      }
      // groupId -> product URL (for linked colour swatches in this results page)

      return products;
    }
  );

  function refreshRecentlyViewData(){
    var storeData = localStorage.getItem("wizzy_store");
    if (storeData) {
      var parsedStore = JSON.parse(storeData);
      parsedStore.VIEWED_PRODUCTS = JSON.parse(localStorage.getItem('VIEWED_PRODUCTS'));
      localStorage.setItem("wizzy_store", JSON.stringify(parsedStore));
    }
  }

  function buildSwatchesFromCombinedListing(attr, product, urlByGroupId) {
    var raw = attr && attr.values && attr.values[0] && attr.values[0].value
      ? attr.values[0].value[0]
      : null;
    if (!raw) return [];

    var children;
    try {
      children = typeof raw === "string" ? JSON.parse(raw) : raw;
    } catch (e) {
      console.error("Failed to parse combined_listing_children", e);
      return [];
    }

    if (!Array.isArray(children)) return [];

    var currentGroupId = product.groupId != null ? String(product.groupId) : "";
    var currentId = product.id != null ? String(product.id) : "";
    var colourSwatches = [];
    var seen = {};

    children.forEach(function (child) {
      if (!child || !Array.isArray(child.parentOptions)) return;

      var colourOpt = child.parentOptions.find(function (opt) {
        var name = String((opt && opt.name) || "").toLowerCase();
        return name === "colour" || name === "color";
      });
      if (!colourOpt || !colourOpt.value) return;

      var colourName = String(colourOpt.value);
      if (seen[colourName]) return;
      seen[colourName] = true;

      var childGroupId = child.groupId != null ? String(child.groupId) : "";
      var childVariationId = child.variationId != null ? String(child.variationId) : "";
      var isActive =
        (childGroupId !== "" && childGroupId === currentGroupId) ||
        (childVariationId !== "" && childVariationId === currentId);

      var hex = colourOpt.hex || "";
      var productUrl = isActive
        ? product.url || ""
        : (urlByGroupId && urlByGroupId[childGroupId]) ||
          child.url ||
          (child.handle ? "/products/" + child.handle : "");

      colourSwatches.push({
        name: colourName,
        hex: hex,
        url: productUrl,
        variationId: childVariationId,
        groupId: childGroupId,
        isActive: isActive,
        isLinkedProduct: isActive ? "false" : "true",
        hasHex: !!hex,
      });
    });

    return colourSwatches;
  }

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(data) {
      window.wizzyConfig.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";
      data.search.configs.pagination.appendInExistingList = !0;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 1000,
          mobile: 1000
      }
      window.wizzyConfig.search.configs.facets.configs =
      window.wizzyConfig.search.configs.facets.configs.map(obj => {
      if (obj.key === "sellingPrice") {
          obj.buckets = [
          { from: 1000, to: 2000 },
          { from: 2000, to: 4000 },
          { from: 4000, to: 6000 },
          { from: 6000, to: 8000 },
          { from: 8000, to: 20000 }
          ];
      }

      return obj;
      });
      data.filters.configs.layout = "v1";
      data.filters.configs.keepOpenedInMobileAfterApply = !0;
      data.search.configs.facets.leftFacets.mobileCollapsible = !0;

  return data;
  });

  window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  function(data) {
    try {
      var facets = data && data.response && data.response.payload && data.response.payload.facets;

      if (Array.isArray(facets)) {
        facets.forEach(function(facet) {
          if (
            facet &&
            facet.key === "sellingPrice" &&
            Array.isArray(facet.data)
          ) {
            facet.data = facet.data.filter(function(value) {
              return value && value.count > 0;
            });
          }
        });
      }
    } catch (error) {
      console.log(error);
    }

    return data;
  }
);


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(data) {
  window.wizzyConfig.search.view.templates.facets.rangeListItem = "#wizzy-facet-range-list-item";
  data.search.configs.pagination.appendInExistingList = !0;
  window.wizzyConfig.search.configs.facets.configs =
  window.wizzyConfig.search.configs.facets.configs.map(obj => {
  if (obj.key === "sellingPrice") {
      obj.buckets = [
      { from: 1000, to: 2000 },
      { from: 2000, to: 4000 },
      { from: 4000, to: 6000 },
      { from: 6000, to: 8000 },
      { from: 8000, to: 20000 }
      ];
  }

  return obj;
  });
  data.filters.configs.layout = "v1";
  data.filters.configs.keepOpenedInMobileAfterApply = !0;
  data.search.configs.facets.leftFacets.mobileCollapsible = !0;


  return data;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      try {
        var products = data.response?.payload?.result;
  
        if (products && products.length > 0) {
          products.forEach((product) => {
            if (product.price && typeof product.price === "object") {
              var minPrice = Math.min(
                ...product.price.map((value) => parseFloat(value))
              );
              product.price = minPrice.toFixed(2);
            }

            if (product.sellingPrice && typeof product.sellingPrice === "object") {
              var minSellingPrice = Math.min(
                ...product.sellingPrice.map((value) => parseFloat(value))
              );
              product.sellingPrice = minSellingPrice.toFixed(2);
            }

            if (product.discount && typeof product.discount === "object") {
              var minDiscount = Math.min(
                ...product.discount.map((value) => parseFloat(value))
              );
              product.discount = minDiscount.toFixed(2);
            }

            if (
              product.discountPercentage &&
              typeof product.discountPercentage === "object"
            ) {
              var minDiscountPercentage = Math.min(
                ...product.discountPercentage.map((value) => parseFloat(value))
              );
              product.discountPercentage = minDiscountPercentage.toFixed(2);
            }

            if (product.price && product.sellingPrice) {
              let discount = getFloatVal(
                product.price - product.sellingPrice
              ).toFixed(2);

              if (discount && discount > 0.1) {
                product.discount = discount;
                product.discountPercentage = Math.round(
                  getFloatVal(
                    ((product.price - product.sellingPrice) / product.price) * 100
                  )
                );
              }
            }
          });
        }
      } catch (error) {
        console.log("error",error);
      }

      return data;
    },2
  );
   
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
    data.showOOSProductsInOrder= "true";
    document.querySelector('.search__button.search__button--reset').click();

    if (window.wizzyLazyAssetUtils) {
      window.wizzyLazyAssetUtils.currentEle = null;
    }

    const inventorySources = getMarketInventorySource();
    data.inventorySources = JSON.stringify(inventorySources);
    return data;
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      var total = data?.data?.response?.payload?.total;
      var totalcountel = document.querySelector(
        ".filters__drawer-heading span"
      );
      var countEl = document.querySelector(
        ".wizzy-filters-mobile-entry [data-results-count]"
      );
      if (totalcountel != null && total != null) {
        totalcountel.textContent = total + " Results";
      }

      if (countEl != null && total != null) {
        countEl.textContent = total + " Results";
      }

      document.dispatchEvent(new CustomEvent("wizzy:results-rendered"));

      return data;
    }
  );
      window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTER_EXECUTED,
    function (data) {

    data.filters.showOOSProductsInOrder= "true";
    data.filters.inventorySources = getMarketInventorySource();

    return data;
    });
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {

    data.showOOSProductsInOrder= "true";
    const inventorySources = getMarketInventorySource();
    data.inventorySources = JSON.stringify(inventorySources);
    return data;
    });
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
        refreshRecentlyViewData();
        const storeData = localStorage.getItem("wizzy_store");


          if (storeData) {
          const parsedStore = JSON.parse(storeData);

          const viewedProducts = parsedStore?.VIEWED_PRODUCTS;
          if (Array.isArray(viewedProducts) && viewedProducts.length) {
            data.isRecentlyViewPresent = true;

          }
          else {
            document.body.classList.add("recently-not-present");
            data.isRecentlyViewPresent = false;
          }
        }


      return data;
    },
    3
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
      try {
        if (data.isForDefault) {
          refreshRecentlyViewData();
          const storeData = localStorage.getItem("wizzy_store");
          if (storeData) {
            const parsedStore = JSON.parse(storeData);
            const viewedProducts = parsedStore?.VIEWED_PRODUCTS;

            if (Array.isArray(viewedProducts) && viewedProducts.length) {
              // Match native predictive-search MAX_ITEMS = 6
              data.products = viewedProducts.slice(0, 6);
              data.isRecentlyViewPresent = true;
            }
          }
        }
      } catch (e) {
        console.error("Error parsing wizzy_store from localStorage", e);
      }

      return data;
    },
    2
  );

  // Clear recently viewed products (default autocomplete strip)
  document.addEventListener("click", function (e) {
    var clearBtn = e.target.closest(".wizzy-recently-viewed-clear");
    if (!clearBtn) return;

    e.preventDefault();
    e.stopPropagation();

    try {
      var storeData = localStorage.getItem("wizzy_store");
      if (storeData) {
        var parsedStore = JSON.parse(storeData);
        parsedStore.VIEWED_PRODUCTS = [];
        localStorage.removeItem('VIEWED_PRODUCTS');
        localStorage.setItem("wizzy_store", JSON.stringify(parsedStore));
      }
    } catch (err) {
      console.error("Error clearing wizzy VIEWED_PRODUCTS", err);
    }

    document.body.classList.add("recently-not-present");
    var strip = clearBtn.closest(".wizzy-autocomplete-top-products--recently-viewed");
    if (strip) strip.remove();
  });

  // Keep Wizzy autocomplete inside the header search panel (like native predictive-search)
  var wrapperStyleObserver = null;
  var mountScheduled = false;

  function mountWizzyAutocompleteInSearch() {
    var wrapper = document.querySelector(".wizzy-autocomplete-wrapper");
    var host = document.getElementById("PredictiveSearchResults");
    var searchEl = document.querySelector("predictive-search.search, .search");
    if (!wrapper || !host) return;

    if (wrapper.parentElement !== host) {
      host.appendChild(wrapper);
    }

    // Kill Wizzy's absolute top/left overlay positioning
    if (
      wrapper.style.top ||
      wrapper.style.left ||
      wrapper.style.position === "absolute" ||
      wrapper.style.position === "fixed"
    ) {
      wrapper.style.top = "";
      wrapper.style.left = "";
      wrapper.style.right = "";
      wrapper.style.bottom = "";
      wrapper.style.position = "";
    }

    var isVisible = window.getComputedStyle(wrapper).display !== "none";
    if (searchEl) {
      searchEl.classList.toggle("wizzy-autocomplete-active", isVisible);
    }
    document.body.classList.toggle("wizzy-autocomplete-active", isVisible);

    if (!wrapperStyleObserver) {
      wrapperStyleObserver = new MutationObserver(scheduleMountWizzyAutocomplete);
      wrapperStyleObserver.observe(wrapper, {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }
  }

  function scheduleMountWizzyAutocomplete() {
    if (mountScheduled) return;
    mountScheduled = true;
    requestAnimationFrame(function () {
      mountScheduled = false;
      // mountWizzyAutocompleteInSearch();
    });
  }

  // mountWizzyAutocompleteInSearch();

  new MutationObserver(function () {
    if (wrapperStyleObserver && !document.querySelector(".wizzy-autocomplete-wrapper")) {
      wrapperStyleObserver.disconnect();
      wrapperStyleObserver = null;
    }
    scheduleMountWizzyAutocomplete();
  }).observe(document.body, { childList: true, subtree: true });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // scheduleMountWizzyAutocomplete();
      return data;
    },
    1
  );
}